import styled from 'styled-components';
import React, {FC} from 'react';

import {Icon} from '../../molecules/icon';
import {mediaBreakpointDown} from '../../../lib/styleVariables';
import {StylableProps, DesignVersionType} from '../../../lib/styleHelpers';

export const SUPPORTED_SOCIAL_MEDIA = ['facebook', 'twitter', 'instagram', 'linkedin', 'medium', 'email'] as const;

export type SocialMediaTypes = typeof SUPPORTED_SOCIAL_MEDIA[number];

export interface SocialMediaLink {
  title: string;
  href: string;
  type: SocialMediaTypes | null | undefined;
}

interface SocialMediaStyleProps extends StylableProps {
  isVertical?: boolean;
  $css?: string;
}

interface SocialMediaLinksProps extends SocialMediaStyleProps {
  links: SocialMediaLink[];
  size?: number;
  $css?: string;
  designVersion?: DesignVersionType;
}

const StyledSocialMediaWrapper = styled.div<SocialMediaStyleProps>`
  text-align: left;
  display: flex;
  flex-direction: ${props => (props.isVertical ? 'column' : 'row')};
  align-items: center;
`;

const StyledBottomLeftSocialLink = styled.a<SocialMediaStyleProps>`
  display: inherit;
  margin-right: ${props => (props.isVertical ? 0 : 20)}px;
  margin-bottom: ${props => (props.isVertical ? 20 : 0)}px;
  color: inherit;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }

  ${mediaBreakpointDown('tablet')} {
    text-align: left;
    margin-right: 15px;
  }

  ${props => props.$css};
`;

const StyledIcon = styled(Icon)`
  fill: currentColor;
`;

export const SocialMediaLinks: FC<SocialMediaLinksProps> = props => {
  const {links, isVertical, size, $css, designVersion} = props;

  if (links && links.length > 0)
    return (
      <StyledSocialMediaWrapper {...props} isVertical={isVertical}>
        {links
          .map((link: SocialMediaLink) => {
            if (!link.type)
              return null;
            const linkType: SocialMediaTypes = link.type;

            return (
              SUPPORTED_SOCIAL_MEDIA.includes(linkType) && (
                <StyledBottomLeftSocialLink key={linkType} href={link.href} isVertical={isVertical} css={$css}>
                  <StyledIcon
                    name={linkType}
                    size={size || 16}
                    useR4={designVersion === 'r4'}
                  />
                </StyledBottomLeftSocialLink>
              )
            );
          })
          .filter(Boolean)}
      </StyledSocialMediaWrapper>
    );

  return null;
};
